import {AxiosInstance} from "axios";
import DictionaryItem from "../model/dictionary/DictionaryItem";

/**
 * Api for lead type.
 */
export default class LeadTypeApi {
	constructor(public readonly axiosInstance: AxiosInstance) { }

	/**
	 * Fetch lead types.
	 * @returns {Promise<DictionaryItem[]>} Promise containing all lead types.
	 */
	fetchLeadTypes(): Promise<DictionaryItem[]> {
		const url = `/api/web/leads/lead_types`;
		return this.axiosInstance.get(url).then(resp => resp.data.map(DictionaryItem.fromJson));
	}

	/**
	 * Create lead type action.
	 */
	createLeadType(data: DictionaryItem): Promise<DictionaryItem> {
		const url = `/api/web/leads/lead_types`;
		return this.axiosInstance.post(url, data.toJson()).then(resp => DictionaryItem.fromJson(resp.data));
	}

	/**
	 * Update lead type action.
	 */
	updateLeadType(leadTypeId: string, data: DictionaryItem): Promise<DictionaryItem> {
		const url = `/api/web/leads/lead_types/${leadTypeId}`;
		return this.axiosInstance.put(url, {name: data.name}).then(resp => DictionaryItem.fromJson(resp.data));
	}

	/**
	 * Update lead type sort order.
	 * @param {DictionaryItem[]} leadTypes
	 * @returns {Promise<DictionaryItem[]>}
	 */
	updateSortOrder(leadTypes: DictionaryItem[]) {
		const url = `/api/web/leads/lead_types/order`;
		const leadTypeIds = leadTypes.map(lt => lt.id);
		return this.axiosInstance.put(url, leadTypeIds);
	}
}